import type { Accessor } from "solid-js";
import type { AbstractPowerSyncDatabase } from "@powersync/common";
import type { PowerSyncDrizzleDB } from "@cashsync/powersync";
import { usePowerSyncContext } from "@/providers/power-sync-context";
import { useDrizzle } from "@/hooks/use-drizzle";
import { useSession } from "@/lib/auth";

export interface FinanceDeps {
  db: Accessor<AbstractPowerSyncDatabase | null>;
  drizzle: Accessor<PowerSyncDrizzleDB | null>;
  userId: Accessor<string | undefined>;
}

/** Common dependencies of all hooks/views in the financial domain. */
export function useFinanceDeps(): FinanceDeps {
  const { db } = usePowerSyncContext();
  const drizzle = useDrizzle();
  const session = useSession();
  return { db: () => db(), drizzle, userId: () => session.userId() || undefined };
}
